import { Formik, Form, Field,ErrorMessage } from "formik";
import * as yup from 'yup';
import { emlakBasvuruValidation } from "../../../validations/EmlakBasvuru";
import ResponsiveTabs from "../../../components/OB/Tabbar";
import { Box ,CircularProgress} from "@mui/material";
import { useEffect, useState } from "react";
import BinaBasvuru from "./Bina-Basvuru";
import ArsaBasvuru from "./Arsa-Basvuru";
import AraziBasvuru from "./Arazi-Basvuru";
import { useNavigate } from "react-router";
import  SessionStorageService  from "../../../services/StorageService";
import AciklamaAndUserControlPopup from "../../../components/OB/popups/aciklama-usercontrol-popup";

const EmlakBasvuru = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event:any, newValue:any) => {
    setValue(newValue);
  };
  let user = SessionStorageService.getUserInfo();
  const [userControlPopup, setUserControlPopup] = useState(false);
  const navigate = useNavigate();
  const closeUserControlPopup = () => {
    setUserControlPopup(false);
    navigate(-1);
  }
  const [isLoad, setIsLoad] = useState(true);
  useEffect(() => {

    if (user == null) {
        
        setUserControlPopup(true);
    }else{
      setIsLoad(false);
    }
    
  }, []);
  return (
    isLoad ? <>
  <div className="d-flex align-self-strech justify-content-center align-items-center"> <CircularProgress /></div>
    {userControlPopup ?(
           
                <AciklamaAndUserControlPopup
                 open={userControlPopup}
                 handleClose={closeUserControlPopup}
                 isUserControlPopUp={true}
                  description={"Bu sayfayı kullanmak için giriş yapmalısınız."}
                />
             
          ):null}
  </>:
    <div>
      <ResponsiveTabs
        items={[
          { title: "Bina", onClick: () => console.log("Tab 1 clicked") },
          { title: "Arsa", onClick: () => console.log("Tab 2 clicked") },
          { title: "Arazi", onClick: () => console.log("Tab 3 clicked") },
        ]}
        value={value}
        onChange={handleChange}
        spreadWidth={false}
      />
      <Box className="pt-2">
        {value === 0 && <BinaBasvuru/>}
        {value === 1 && <ArsaBasvuru/>}
        {value === 2 && <AraziBasvuru/>}
      </Box>
    </div>
  );
};

export default EmlakBasvuru;